import { httpRequest } from '@/apis/request'

enum Apis {
  getEngraving = 'load_engraving_setting',
}

export function getEngravingSetting(params: { setting_id: number }) {
  return httpRequest.post(Apis.getEngraving, params)
}
